<template lang="pug">
#app
  nav.navbar.is-white(style='border-top: 2px solid #209cee')
    .navbar-brand
      router-link.navbar-item(to='/')
        .title.is-4
          | Sto<span style='opacity: 0.4'>c</span>ked
          small.is-hidden-mobile(style='font-weight: normal; font-size: 0.8em;') . Your piece of the world
    .navbar-menu
      .navbar-end
        .navbar-item
          .field.is-grouped
            p.control
              a.twitter-button.button(data-social-network='Twitter', data-social-action='tweet', data-social-target='https://stocked.honeymoney.io', target='_blank', href='https://twitter.com/intent/tweet?text=Stocked. How much you have invested in your favourite companies if you use index funds.&hashtags=FIRE,investing,indexinvesting,indexfunds&url=https://stocked.honeymoney.io&via=bee_saving')
                span.icon: i.fab.fa-twitter
                span Tweet
            //- p.control
            //-   a.hm_button.button(href="https://HoneyMoney.io/?utm_source=stocked" target='_blank')
            //-     span.icon: img(src='./assets/bee.png')
            //-     | &nbsp;&nbsp;&nbsp;HoneyMoney
  router-view

  footer.footer
    .columns.is-vcentered
      .column.content.has-text-centered
        p
          strong Stocked
          |  by&nbsp;
          a.hm_button(href="https://HoneyMoney.io/?utm_source=stocked" target='_blank') HoneyMoney
          span , logos provided by <a href="https://clearbit.com">Clearbit</a>.
        p Most recent holding details update <b>March 20th, 2024</b>.
</template>

<script>
export default {
  components: {
    honeymoney_block: require('./components/honeymoney_block.vue').default
  },
  mounted() {
    mixpanel.track_links('.twitter-button', 'clicked twitter button')
    mixpanel.track_links('.hm_button', 'clicked HM button')
  }
}
</script>

<style lang="sass">
@import url('https://rsms.me/inter/inter-ui.css')
html, body, button, input, select, textarea
  font-family: 'Inter UI', sans-serif !important
@supports (font-variation-settings: normal)
  html, body, button, input, select, textarea
    font-family: 'Inter UI var alt', sans-serif !important
    font-feature-settings: 'tnum', 'ss01', 'cpsp'

html, body
  background: #f0f2f4
.nowrap
  white-space: nowrap !important
.twitter-button
  background-color: #55acee
  color: #fff
  border-color: transparent !important
  &:hover
    background-color: #49a6ed
    color: #fff
.table.is-borderless
  td
    border: none

.footer
  padding-bottom: 3rem

@media screen and (max-width: 770px)
  .section
    padding: 3rem 0.2rem
.navbar
  display: flex
  align-items: stretch
.navbar-menu, .navbar-start, .navbar-item
  flex-grow: 1
  flex-shrink: 0
  display: flex
  align-items: stretch
  .navbar-start
    justify-content: flex-start
    margin-right: auto
  .navbar-end
    justify-content: flex-end
    margin-left: auto
    align-items: flex-end

.navbar-item
  display: flex
  align-items: center

@media screen and (max-width: 770px)
  table.mobile_table
    width: 100%
    border: 0
    caption
      font-size: 1.3em
    thead
      border: none
      clip: rect(0 0 0 0)
      height: 1px
      margin: -1px
      overflow: hidden
      padding: 0
      position: absolute
      width: 1px
    tr
      border-bottom: 3px solid #ddd
      display: block
      margin-bottom: 2em
      &:last-child
        margin-bottom: 0
    td
      border-bottom: 1px solid #ddd
      display: block
      font-size: .8em
      text-align: right !important
      width: auto
      &::before
        content: attr(data-label)
        float: left
        font-weight: bold
      &:last-child
        border-bottom: 0
    td.logo
      height: auto
      width: auto
    tfoot td
      text-align: center !important
</style>
